export enum EqualitySigns {
  '>=' = '>=',
  '=' = '=',
  '<=' = '<=',
}

export type EqualitySignType = `${EqualitySigns}`;
